import { DatePicker } from '@mui/lab';
import { TextField } from '@mui/material';
import { useFormContext, useController } from 'react-hook-form';

interface QuoteExpirationDateProps {
  initialDate: Date;
}
export function QuoteExpirationDate({ initialDate }: QuoteExpirationDateProps) {
  const name = 'expirationDate';
  const {
    formState: { errors },
  } = useFormContext();
  const {
    field: { ref, onChange, value, onBlur },
  } = useController({
    name,
    rules: {
      required: { message: 'Expiration Date is Required', value: true },
    },
    defaultValue: initialDate,
  });
  return (
    <DatePicker
      value={value}
      onChange={onChange}
      renderInput={params => (
        <TextField
          id={name}
          {...params}
          onBlur={onBlur}
          fullWidth
          inputRef={inputRef => {
            if (params.inputRef && typeof params.inputRef === 'function') {
              params.inputRef(inputRef);
            }
            ref(inputRef);
          }}
          label='Expiration Date'
          inputProps={{ ...params.inputProps, 'aria-label': 'Expiration Date' }}
          placeholder='Expiration Date'
          error={Boolean(errors.expirationDate)}
          helperText={errors.expirationDate?.message}
        />
      )}
      minDate={new Date()}
      mask='__-__-__'
      inputFormat='MM-dd-yy'
    />
  );
}
